var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification1Icon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_12458",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H32V32H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_12458)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0003 2.66669C15.7097 2.66669 15.4243 2.66935 15.1443 2.67335L14.323 2.69602L13.9243 2.71335L13.1523 2.75869L12.415 2.82002C6.03499 3.43869 3.43899 6.03469 2.82033 12.4147L2.75899 13.152L2.71366 13.924C2.70699 14.0547 2.70033 14.188 2.69633 14.3227L2.67366 15.144L2.66833 15.568L2.66699 16C2.66699 16.2907 2.66966 16.576 2.67366 16.856L2.69633 17.6774L2.71366 18.076L2.75899 18.848L2.82033 19.5854C3.43899 25.9654 6.03499 28.5614 12.415 29.18L13.1523 29.2414L13.9243 29.2867C14.055 29.2934 14.1883 29.3 14.323 29.304L15.1443 29.3267L16.0003 29.3334L16.8563 29.3267L17.6777 29.304L18.0763 29.2867L18.8483 29.2414L19.5857 29.18C25.9657 28.5614 28.5617 25.9654 29.1803 19.5854L29.2417 18.848L29.287 18.076C29.2937 17.9454 29.3003 17.812 29.3043 17.6774L29.327 16.856L29.3337 16L29.327 15.144L29.3043 14.3227L29.287 13.924L29.2417 13.152L29.1803 12.4147C28.5617 6.03469 25.9657 3.43869 19.5857 2.82002L18.8483 2.75869L18.0763 2.71335C17.9435 2.70687 17.8106 2.70109 17.6777 2.69602L16.8563 2.67335L16.4323 2.66802L16.0003 2.66669ZM19.0577 12.3907C19.2976 12.1516 19.6196 12.0127 19.9582 12.0024C20.2968 11.992 20.6266 12.111 20.8807 12.335C21.1348 12.5591 21.2941 12.8714 21.3262 13.2087C21.3583 13.5459 21.2609 13.8827 21.0537 14.1507L20.943 14.276L15.6097 19.6094C15.3801 19.8389 15.0746 19.9768 14.7506 19.9972C14.4265 20.0176 14.1062 19.919 13.8497 19.72L13.7243 19.6094L11.0577 16.9427C10.8185 16.7027 10.6797 16.3808 10.6694 16.0422C10.659 15.7036 10.7779 15.3737 11.002 15.1196C11.226 14.8656 11.5384 14.7063 11.8756 14.6742C12.2129 14.642 12.5497 14.7395 12.8177 14.9467L12.943 15.0574L14.667 16.78L19.0577 12.3907Z",
    fill: "#7B51F1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification1Icon);
export default __webpack_public_path__ + "static/media/notification1-icon.51981fb683354767e93d7a17146d0fbc.svg";
export { ForwardRef as ReactComponent };